import {
    Card,
    Button,
    Loading,
    BaseTable,
    ActionButton,
} from "components"
import { useProfileDetail } from "../utils/useProfileDetail"
import moment from "moment"
import { useEffect, useState } from "react"
import { FormStateProjectProfile } from "../types/ProfileTypes"
import { Controller, FormProvider, useFieldArray, useForm } from "react-hook-form"
import { useApi } from "utils"
import { yupResolver } from "@hookform/resolvers/yup"
import toast from "react-hot-toast"
import { FormResourcesType, validationFormResourcesSchema } from "../types/ResourcesTypes"
import { TableResourcesItem } from "../components/TableResourcesItem"
import { useResourcesDetail } from "../utils/useResourcesDetail"
import { useEmployeeList } from "../utils/useEmployeeList"
import { group_list, status_resources } from "../utils/resourcesOption"

interface TabProps{
    action?:string
    project_id?:string
    approval_view?:boolean
    data_profile?:FormStateProjectProfile
}

export function TabResources(props:TabProps): JSX.Element {
    const isDisabledForm = Boolean(props.action === 'view')
    const api = useApi()
    const defaultValues = {
        items: []
    }
    const methods = useForm<FormResourcesType>({
        defaultValues,
        resolver:yupResolver(validationFormResourcesSchema)
    })
    const { handleSubmit, setValue } = methods;
    
    const [editField, setEditField] = useState<number | null>(null)

    const { fields, append, remove } = useFieldArray({
        control: methods.control,
        name: "items"
    })
    const [isLoading , setLoading] = useState(true)
    const { data } = useProfileDetail(props.project_id)
    const { dropdown:dropdownEmployee } = useEmployeeList()
    const { detailResources, refetchResources } = useResourcesDetail(props.project_id)
    const [dataProfile, setDataProfile] = useState<FormStateProjectProfile | null>(null);
    const [dayBehind,setDayBehind ] = useState(0)
    const [weekBehind,setWeekBehind ] = useState(0)
   
    
    useEffect(() => {
        if (isLoading && ((!data || data.length === 0) || !detailResources)) return;

        setDataProfile(data[0])
        setValue('items',detailResources)
        const startDate = data[0].start_date;
        const dueDate = data[0].due_date;
        const today = moment().toDate()
        // Hitung durasi (hari)
        const dayBehind = startDate ? moment(dueDate).diff(moment(today), "days") : 0;
        let weekBehind =  startDate ? moment(today).diff(moment(startDate), "days") : 0;
        weekBehind = Math.ceil(weekBehind / 7 );

        setDayBehind(dayBehind)
        setWeekBehind(weekBehind)
        setLoading(false)
        // eslint-disable-next-line
    },[data, detailResources])
    

    const onSubmit = async (value: FormResourcesType) => {
        await toast
        .promise(api.post(`/project/save_hrd_project_resources?project_id=${dataProfile?.project_id}`, value), {
            loading: "Loading...",
            success: (res) => {
                console.log(res.data);
                return res.data.message
            },
            error: (err) => err.response.data.detail?.message ?? err.response.data.message
        })
        .then(() => {
            refetchResources()
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        })
        .catch((err) => {
            throw new Error(err);
        });
    };

    const onError = (errors: any) => {
        Object.values(errors).forEach((error: any) => {
            if (error?.message) {
                toast.error(error.message)
            } else if (typeof error === 'object') {
                Object.values(error).forEach((subError: any) => {
                    if (subError?.message) toast.error(subError.message)
                })
            }
        })
    };

    if(isLoading) return (
        <Loading
        loading={isLoading}
        errorText="No data available"
      />
    )

    return (
        <section className="">
            <section>
                <Card>
                    <Card.Body>
                      
                        <div className="flex flex-row w-full"> 
                            <div className="grow">
                                <div className="text-2xl font-bold uppercase py-4">
                                    {dataProfile?.project_name}
                                </div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>START DATE</td>
                                            <td>:</td>
                                            <td>{(dataProfile?.start_date) ? moment(dataProfile.start_date).format('DD/MM/YYYY') : '-'}</td>
                                        </tr>
                                        <tr>
                                            <td>DUE DATE</td>
                                            <td>:</td>
                                            <td>{(dataProfile?.due_date) ? moment(dataProfile.due_date).format('DD/MM/YYYY') : '-'}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="flex gap-2">
                                <div className="min-h-[80px] flex flex-col border border-black">
                                    <div className="min-h-[40px] bg-black font-bold text-white text-sm text-center py-2 px-2">DURATION | DAYS</div>

                                    <section className="grow font-bold flex flex-col justify-center gap-1 p-3 text-center">
                                        <span className="text-lg">{dayBehind}</span>
                                        <span className="text-sm">Leaf of days</span>
                                    </section>
                                </div>
                                <div className="min-h-[80px] flex flex-col border border-black">
                                    <div className="min-h-[40px] bg-black font-bold text-white text-sm text-center py-2 px-2">START | WEEKS</div>

                                    <section className="grow font-bold flex flex-col justify-center gap-1 p-3 text-center">
                                        <span className="text-lg">{weekBehind}</span>
                                        <span className="text-sm">Weeks</span>
                                    </section>
                                </div>
                            </div>
                        </div>
                 
                    </Card.Body>
                </Card>
            </section>

            <section>
            <FormProvider {...methods}>
                <Card>
                    <Card.Body>
                        <div>
                            <BaseTable>
                                <thead className="top-0 z-1 !bg-black !text-white">
                                    <tr>
                                        <th>NO</th>
                                        <th>GROUP</th>
                                        <th>TRADER</th>
                                        <th>DUTY OF CARE</th>
                                        <th>REPORT TO</th>
                                        <th>STATUS</th>
                                        <th>ACTION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {fields.map((arrField, key) => {
                                        return (
                                                <Controller
                                                    key={arrField.id}
                                                    control={methods.control}
                                                    name={`items.${key}`}
                                                    render={({ field }) => {
                                                    if (editField === key) {
                                                        return (
                                                            <TableResourcesItem
                                                                dataProject={dataProfile!}
                                                                employee={dropdownEmployee}
                                                                key={arrField.id}
                                                                index={editField}
                                                                action="edit"
                                                                isHideForm={false}
                                                                defaultValues={field.value}
                                                                onCancelEditing={() => setEditField(null)}
                                                                onSubmitData={(value) => {
                                                                    field.onChange(value)
                                                                    setEditField(null)
                                                                }}
                                                            />
                                                            
                                                        )
                                                    } else {
                                                        return (
                                                            <tr>
                                                                <td className="text-center">{key + 1}</td>
                                                                <td> {group_list.find(i => Number(i.value) === Number(field.value.group_card))?.label}</td>
                                                                <td>{field.value.card_name}</td>
                                                                <td>{field.value.description}</td>
                                                                <td>{field.value.employee_name}</td>
                                                                <td>{status_resources.find(i => Number(i.value) === Number(field.value.status))?.label}</td>
                                                                <td>
                                                                <section className="flex justify-center items-center">
                                                                    {!isDisabledForm && (
                                                                        <>
                                                                            <ActionButton.Update
                                                                                permission="AT021"
                                                                                onClick={() => setEditField(key)}
                                                                            />
                                                                            <ActionButton.Delete
                                                                                permission="AT021"
                                                                                onClick={() => remove(key)}
                                                                            />
                                                                        </>
                                                                    )}
                                                                    
                                                                </section>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                    }}
                                                />
                                           
                                        )
                                    })}

                                    {!isDisabledForm && (
                                    <TableResourcesItem
                                        dataProject={dataProfile!}
                                        key={fields.length}
                                        employee={dropdownEmployee}
                                        action="add"
                                        onSubmitData={(value) => append(value)}
                                    />
                                    )}
                                </tbody>
                            </BaseTable>
                        </div>
                        {/* <div className="flex mt-5">
                            <div className="grow"></div>
                            <div>
                                <table className="table">
                                    <tbody className="font-bold">
                                        <tr>
                                            <td>TOTAL BUDGET</td>
                                            <td className="min-w-[5px] text-center">:</td>
                                            <td className="min-w-[100px] text-right">{convertNumber(Number(totalBudget)).intoCurrency}</td>
                                        </tr>
                                        <tr>
                                            <td>ACTUAL BUDGET</td>
                                            <td className="min-w-[5px] text-center">:</td>
                                            <td className="min-w-[100px] text-right">{convertNumber(Number(totalActual)).intoCurrency}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div> */}
                        <div className="flex justify-end mt-[30px] mb-[30px]">
                            <Button color="primary" 
                                disabled={isDisabledForm}
                                className="min-w-[100px]"
                                type="button"
                                permission="ST19"
                                onClick={handleSubmit(onSubmit, onError)}
                            >
                                { props.action === 'edit' ? 'SAVE': 'CREATE'}
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
            </FormProvider>

            </section>
        </section>
    )
}
